var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSensor1Legend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 10,
    viewBox: "0 0 35 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2156 -432.687)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "sensor1a",
    x2: 35,
    transform: "translate(2156 437.5)",
    fill: "none",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    className: "sensor1b",
    transform: "translate(2168.5 432.687)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "sensor1c",
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "sensor1d",
    cx: 5,
    cy: 5,
    r: 4.5,
    fill: "none"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSensor1Legend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sensor1-legend.7f3792d805af196656f60886dfae8fab.svg";